module.exports = __webpack_public_path__ + "7450be76674636da55fb50efd16bb235.pdf";